import { normalizeServerUrl } from "@ronin/core";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { AuthForm } from "../components/auth-form.js";
import { ConfirmDialog } from "../components/notes/dialogs.js";
import { useConfirm } from "../lib/use-confirm.js";
import { storedAccount } from "../platform/offline/index.js";
import { serverUrl } from "../platform/server.js";
import { connectToServer } from "../platform/session.js";

/** spec08 FR5: the app asks which Ronin server to use before anything else. */
export function ConnectPage() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const confirm = useConfirm();

  return (
    <>
      <AuthForm
        title="Connect to your server"
        description="Enter the address of your Ronin server."
        submitLabel="Connect"
        fields={[
          {
            name: "server",
            label: "Server address",
            type: "url",
            autoComplete: "url",
            hint: "For example ronin.example.com. Only https is supported.",
          },
        ]}
        onSubmit={async ({ server = "" }) => {
          // spec11 FR15: another server means the offline copy and its unsent notes go.
          const url = normalizeServerUrl(server);
          const pending = (await storedAccount())?.pending ?? 0;
          if (url && url !== serverUrl() && pending > 0 && !(await confirm.ask())) return;
          await connectToServer(server, queryClient);
          await navigate({ to: "/login" });
        }}
      />
      <ConfirmDialog
        open={confirm.open}
        title="Switch server?"
        description="Notes that have not synced yet are deleted from this device."
        confirmLabel="Switch anyway"
        onClose={() => confirm.reply(false)}
        onConfirm={() => confirm.reply(true)}
      />
    </>
  );
}
